export default __webpack_public_path__ + "e5efe1285abd860dcf94fc24971365cb.gif";